export const CAMPAIGN_QUESTION_TYPE_ENUMS = {
  STAR: 'STAR',
  YES_NO: 'YES_NO',
  PASS_FAIL: 'PASS_FAIL',
  NUMBER: 'NUMBER',
  TEXT: 'TEXT'
};

export const CAMPAIGN_FOLLOW_UP_TYPE_ENUMS = {
  TEXT: 'TEXT',
  TIME: 'TIME'
};

export const GUIDE_STATUS_ENUMS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
};

export const CAMPAIGN_STATUS_ENUMS = GUIDE_STATUS_ENUMS;

export const GUIDE_IMPORT_SOURCE_TYPE_ENUMS = {
  PDF: 'PDF',
  VIDEO: 'VIDEO'
};

export const CAMPAIGN_TRIGGER_KIND_ENUMS = {
  ALWAYS: 'ALWAYS',
  VIEWED_INSTRUCTIONS: 'VIEWED_INSTRUCTIONS',
  TIME: 'TIME'
};

export const TEAM_MEMBER_ROLE = {
  EDITOR: 'EDITOR',
  ADMIN: 'ADMIN',
  VIEWER: 'VIEWER'
};

// TODO: This will be deprecated. After changes on native client for users revamp this should be removed
export const USER_ROLE_ENUMS = {
  EDITOR: 'EDITOR',
  ADMIN: 'ADMIN',
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  VIEWER: 'VIEWER'
};

export const SWIPE_TRACKER_EVENTS = {
  PAGEVIEW: 'pageview',
  ACTION: 'action',
  SEARCH: 'search'
};

export const FEEDBACK_PARENT_TYPE_ENUM = {
  GUIDE: 'GUIDE',
  INSTRUCTION: 'INSTRUCTION',
  STEP: 'STEP'
};

export const SHAPE_ENUMS = {
  ARROW: 'arrow',
  RECT: 'rectangle',
  LINE: 'line',
  ELLIPSE: 'ellipse'
};

export const SORT_BY_OPTIONS = {
  DRAFT_TITLE: 'DRAFT_TITLE',
  PUBLISHED_TITLE: 'PUBLISHED_TITLE',
  LAST_PUBLISHED: 'LAST_PUBLISHED',
  CREATION_DATE: 'CREATION_DATE',
  LAST_UPDATED: 'LAST_UPDATED',
  ASSIGNED_TO: 'ASSIGNED_TO'
};

export const GUIDE_FILTER_OPTIONS = {
  ALL_GUIDES: 'ALL_GUIDES',
  MY_GUIDES: 'MY_GUIDES',
  TEAM_GUIDES: 'TEAM_GUIDES'
};

// TODO:
// This shall be renamed to something
// specific to knowledge sharing filters
// cause now we have introduced signoffs filter options
// and it gets inconsistent.

export const CUSTOM_FILTER_OPTIONS = {
  TAG: 'TAG',
  TEAM: 'TEAM',
  ASSIGNEE: 'ASSIGNEE',
  WORKSPACE: 'WORKSPACE',
  LANGUAGE: 'LANGUAGE'
};

export const CUSTOM_SIGNOFF_FILTER_OPTIONS = {
  SIGNOFF: 'SIGNOFF',
  START_DATE: 'START_DATE',
  END_DATE: 'END_DATE',
  DATE_OPTION: 'DATE_OPTION',
  GUIDE: 'GUIDE',
  WORKSPACE: 'WORKSPACE',
  TAG: 'TAG'
};

export const STATUS_OPTIONS = {
  ALL: 'ALL',
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT'
};

export const INSTRUCTION_TYPE = {
  INSTRUCTION: 'INSTRUCTION',
  CHECKLIST: 'CHECKLIST'
};

export const TOAST_NOTIFICATIONS_TYPES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

const today = {id: 'today'};
const yesterday = {id: 'yesterday'};
const last7days = {id: 'last7days'};
const last30days = {id: 'last30days'};
const lastMonth = {id: 'lastMonth'};
const weekToDate = {id: 'weekToDate'};
const monthToDate = {id: 'monthToDate'};
const custom = {id: 'custom'};

export const dateRangeOptions = [today, yesterday, last7days, last30days, lastMonth, weekToDate, monthToDate, custom];

export const dateRangeOptionsValues = {
  today,
  yesterday,
  last7days,
  last30days,
  lastMonth,
  weekToDate,
  monthToDate,
  custom
};

export const COOKIE_PREFERENCE_OPTIONS = {
  YES: 'yes',
  NO: 'no'
};

export const DOMAIN_LOGIN_OPTIONS = {
  SSO: 'SSO',
  EMAIL: 'EMAIL',
  PHONE_NUMBER: 'PHONE_NUMBER',
  DOMAIN_PASSWORD: 'DOMAIN_PASSWORD'
};

export const DOMAIN_LOGIN_FORBIDDEN_ACTIONS = {
  SHOW_SSO_DIALOG: 'SHOW_SSO_DIALOG',
  REDIRECT_AND_LOGOUT: 'REDIRECT_AND_LOGOUT'
};
